module.exports = __webpack_public_path__ + "media/images/version_merge/target_card-34962508c39e3bc32bc59e2b1fc50867.jpg";